declare global {
  interface Window {
    Cookiebot?: CookiebotSDK;
  }
}

type ConsentType = 'necessary' | 'preferences' | 'statistics' | 'marketing';

interface CookiebotSDK {
  renew: () => void;
  consent?: {
    method: 'implied' | 'explicit' | null;
    necessary: boolean;
    preferences: boolean;
    statistics: boolean;
    marketing: boolean;
  };
}

function hasConsentForVendor(consentType: ConsentType): boolean {
  const { Cookiebot } = window;
  if (Cookiebot?.consent == null) {
    return false;
  }
  return Cookiebot.consent[consentType];
}

export function enableTrackingAndAnalytics(): boolean {
  return process.env.NODE_ENV === 'production';
}

export function consentAwareScript({
  src,
  consentType,
  async = false,
}: {
  src?: string;
  consentType: ConsentType;
  async?: boolean;
}): HTMLScriptElement {
  const hasConsent = hasConsentForVendor(consentType);

  const script = document.createElement('script');
  script.async = async;

  if (!hasConsent) {
    script.type = 'text/plain';
    script.dataset.cookieconsent = consentType;
  }

  if (src) {
    script.src = src;
  }

  return script;
}

export function onClickShowConsentScreenHandler(e: React.MouseEvent): void {
  e.preventDefault();
  const { Cookiebot } = window;
  if (!Cookiebot) {
    return;
  }

  Cookiebot.renew();
}
